import { ServiceType } from "@/data/model/Enums";
import type { IRoomService, IRoomServiceOrderUseCase, IRoomWithService } from "@/data/model/Room";

import { logWarning } from "@/shared/logging/informations";

import type { IOfferWithScheduleState } from "../model/Offer";

export function getRoomOrderApplications(room: IRoomWithService): IRoomServiceOrderUseCase[] {
    const allOrderApplications = [
        ...getOrderApplications(room.endUserServices),
        ...getOrderApplications(room.operatorServices),
    ];

    // get only unique ids
    const result = allOrderApplications.filter(
        (app, index) => index === allOrderApplications.findIndex((other) => app.id === other.id)
    );

    return result;
}

function getOrderApplications(services: IRoomService[]): IRoomServiceOrderUseCase[] {
    const orderApplications: IRoomServiceOrderUseCase[] = [];

    for (const service of services) {
        if (service.serviceType != ServiceType.Order && service.serviceType != ServiceType.Offer) {
            continue;
        }

        if (!service.orderUseCase) {
            logWarning(`Order use case not set for service ${service.id}`);
            continue;
        }

        orderApplications.push(service.orderUseCase);
    }

    return orderApplications;
}

export function isOfferActivated(offer: IOfferWithScheduleState, roomId: string, orderApplicationId: string) {
    return offer.currentPlanning.some((c) => c.roomId === roomId && c.orderUseCaseId == orderApplicationId);
}
